import React from "react";
import PropTypes from "prop-types";
import { IntlProvider } from "react-intl";
import Link from "../../bundles/main/components/util/Link";
import RowMenu from "../../bundles/main/components/util/RowMenu";
import {translations} from "../../bundles/main/components/util/i18n";

const MenuTitle = ({title, icon, additional_info, isActive = false}) => {
  return (
          <div className={`tab ${isActive ? 'tab-active' : ''}`}>
            <ion-icon name={icon}/>
            <span className="tab-title">{title}</span>
            {additional_info &&
              <div className="additional-info">
                <div>
                  {additional_info}
                </div>
              </div>
            }
          </div>
  )
}

const TabsMenu = ({tabs, active_tab}) => {
  const options = tabs.map(({title, path, icon, additional_info}) => {
    return {
      title: <MenuTitle
              title={title}
              additional_info={additional_info}
              icon={icon}
              isActive={title === active_tab.title}
      />,
      component: Link,
      params: {
        url: path,
        refresh: true,
      },
    };
  });

  return (
          <div className="tabs-menu">
            <RowMenu
              classNameForDropdown={"for-btn-secondary"}
              title={
                <MenuTitle
                  title={active_tab.title}
                  additional_info={active_tab.additional_info}
                  icon={active_tab.icon}
                  isActive
                />
              }
              options={options}
              noTranslation={true}
            />
          </div>
  );
};

const WithIntlProvider = (props) => {
  return (
          <IntlProvider
                  locale={window._FLAIM_LOCALE}
                  key={window._FLAIM_LOCALE}
                  messages={translations[window._FLAIM_LOCALE]}
          >
            <TabsMenu {...props} />
          </IntlProvider>
  );
};

TabsMenu.propTypes = {
  tabs: PropTypes.array.isRequired,
  active_tab: PropTypes.object.isRequired,
};

export default WithIntlProvider;
